'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'compass-drafting';
var width = 512;
var height = 512;
var aliases = ["drafting-compass"];
var unicode = 'f568';
var svgPathData = ['M192.4 80a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z', 'M320.4 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-22.7 68.5c-12.1 7.3-26.2 11.5-41.3 11.5s-29.3-4.2-41.3-11.5l-88.9 160c37.4 22.6 81.2 35.5 128 35.5 91.8 0 171.9-49.9 214.8-124l13.8 8c-45.6 78.9-131 132-228.7 132-49.6 0-96.1-13.7-135.8-37.5l-103 185.4-3.9 7-14-7.8 3.9-7 103.5-186.3C72.4 291.5 45.2 262.2 25.5 228l13.8-8c18.3 31.7 43.5 58.9 73.4 79.8l88.7-159.6 .7-1.3c-15.8-14.6-25.7-35.5-25.7-58.8 0-44.2 35.8-80 80-80s80 35.8 80 80c0 23.2-9.9 44.2-25.7 58.8l.7 1.3 63.9 115c-4.3 3.2-8.7 6.3-13.2 9.2L297.7 148.5zM497.4 507.9L416.6 362.4c4.6-2.8 9.1-5.7 13.5-8.7l81.3 146.4 3.9 7-14 7.8-3.9-7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompassDrafting = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;